/**
 * 리베이트 기반 업체 판별 유틸
 *
 * 혼수업체, 웨딩홀 등 계약 성사 시 리베이트를 받는 구조의 업체.
 * - 상품 등록 시: 계약일자, 계약품목, 계약금, 리베이트%, 리베이트 금액 입력
 * - 발주 등록 시: 계약금/리베이트 기반 금액 정보
 *
 * 대분류 기준: '혼수업체', '웨딩홀'
 * 소분류 fallback: '예복','예물','한복','가전','웨딩홀'
 */

// 리베이트 기반 대분류 이름
const REBATE_PARENT_CATEGORIES = ['혼수업체', '웨딩홀', '허니문'] as const;

// 소분류 fallback (parent 정보가 없을 때 사용)
const REBATE_SUB_CATEGORIES = ['예복', '예물', '한복', '가전', '웨딩홀', '허니문'] as const;

/**
 * vendor 객체로부터 리베이트 기반 업체인지 판별
 * @param vendor - category.parent?.name 또는 category?.name 을 가진 객체
 */
export const isRebateVendor = (vendor: {
  category?: {
    name?: string;
    parent?: { name?: string } | null;
  } | null;
} | null): boolean => {
  if (!vendor?.category) return false;

  // 1순위: parent category (대분류)
  const parentName = vendor.category.parent?.name;
  if (parentName && REBATE_PARENT_CATEGORIES.includes(parentName as any)) return true;

  // 2순위: category name (소분류 fallback)
  const catName = vendor.category.name;
  if (catName && REBATE_SUB_CATEGORIES.includes(catName as any)) return true;

  return false;
};

/**
 * 대분류 이름으로 리베이트 기반 카테고리인지 판별
 * @param parentCategoryName - 대분류 이름 (예: '혼수업체', '웨딩홀')
 */
export const isRebateParentCategory = (parentCategoryName: string): boolean => {
  return REBATE_PARENT_CATEGORIES.includes(parentCategoryName as any);
};

/**
 * 소분류 이름으로 리베이트 기반 카테고리인지 판별
 * @param subCategoryName - 소분류 이름 (예: '예복', '웨딩홀')
 */
export const isRebateSubCategory = (subCategoryName: string): boolean => {
  return REBATE_SUB_CATEGORIES.includes(subCategoryName as any);
};
